"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Agenda = void 0;
const agenda_task_update_1 = __importDefault(require("@app/request/agenda-task-update"));
const i18n_1 = require("@app/util/i18n");
const _ui_1 = require("@ui");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const Agenda = ({ details, positions, auth, loadDetails, workspaceId, disabled, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'ds-viewshift-row' },
            react_1.default.createElement("div", { className: 'ds-viewshift-col-label' }, (0, i18n_1.t)('EDIT_SHIFT_AGENDA_TITLE'))),
        react_1.default.createElement("div", { className: 'ds-viewshift-row' },
            react_1.default.createElement("table", null,
                react_1.default.createElement("tbody", null, details.agenda.map((ag, idx) => {
                    // prepare agenda task's position
                    const pos = ag.positionId &&
                        positions &&
                        positions.some((p) => p.id === ag.positionId)
                        ? Object.assign({}, positions.find((p) => p.id === ag.positionId))
                        : null;
                    if (pos?.name?.length)
                        pos.name = pos.name[0];
                    return (react_1.default.createElement("tr", { key: idx },
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(_ui_1.Flex, null,
                                react_1.default.createElement(_ui_1.Checkbox, { checked: Boolean(ag.done), onChange: (val) => {
                                        void (0, agenda_task_update_1.default)({
                                            workspace: workspaceId,
                                            id: details.id,
                                            task: ag.id,
                                            done: Boolean(val),
                                        }, auth).then(() => {
                                            loadDetails();
                                        });
                                    }, disabled: disabled }),
                                react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_6 }))),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(_ui_1.Flex, null,
                                react_1.default.createElement(_ui_1.Text, { color: disabled ? _ui_1.Text.COLORS.GRAY : _ui_1.Text.COLORS.PRIMARY, weight: _ui_1.Text.WEIGHTS.BOLD, type: _ui_1.Text.TYPES.BODY_MEDIUM }, ag.name),
                                react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_6 }))),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(_ui_1.Flex, null,
                                react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM },
                                    (0, moment_1.default)(details.period.start)
                                        .clone()
                                        .add(ag.start, 'minutes')
                                        .format('HH:mm - '),
                                    (0, moment_1.default)(details.period.start)
                                        .clone()
                                        .add(ag.start + ag.duration, 'minutes')
                                        .format('HH:mm')),
                                react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_6 }))),
                        react_1.default.createElement("td", null, !!pos && (react_1.default.createElement(_ui_1.Flex, null,
                            react_1.default.createElement(_ui_1.Position, { sm: true, pos: pos }),
                            react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_6 }))))));
                }))))));
};
exports.Agenda = Agenda;
